import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import Home from './components/layouts/homePageScroll/Home';
import RecordReleases from './components/layouts/recordLabel/RecordReleases';
import RecordArtists from './components/layouts/recordLabel/RecordArtists';
import RecordSubmissions from './components/layouts/recordLabel/RecordSubmissions';
import LiveThrowdown from './components/layouts/liveExperience/LiveThrowdown';
import LivePastEvents from './components/layouts/liveExperience/LivePastEvents';
import LiveBuyTickets from './components/layouts/liveExperience/LiveBuyTickets';
import LoginAccount from './components/layouts/accounts/LoginAccount';
import CreateAccount from './components/layouts/accounts/CreateAccount';
import Apparel from './components/layouts/apparel/ApparelCollections';
import ApparelTees from './components/layouts/apparel/ApparelTees';
import ApparelHoodies from './components/layouts/apparel/hoodies/Hoodies';
import ApparelMasks from './components/layouts/apparel/masks/Masks';
import ApparelProduct from './components/layouts/apparel/ApparelProductPage';
import FreeShopping from './components/layouts/shoppingCart/FreeShopping';
import ShippingAddressGuest from './components/layouts/shippingCart/ShippingAddressGuest';
import AddNewAddress from './components/layouts/shippingCart/AddNewAddress';
import ShippingAddressLogged from './components/layouts/shippingCart/ShippingAddressLogged';
import ContactUs from './components/layouts/about/ContactUs';

import ApparelState from './components/context/apparel/ApparelState';
import RecordState from './components/context/record/RecordState';
import LiveState from './components/context/liveExperience/LiveState';
import ShoppingState from './components/context/shoping/ShoppingState';
import AddressState from './components/context/address/AddressState';
import AuthState from './components/context/auth/AuthState';
import LiveDelhi from './components/layouts/liveExperience/liveEventLineups/LiveDelhi';
import 'bootstrap/dist/css/bootstrap.css';

import './App.css';

const App = () => {
  return (
    <AuthState>
      <ShoppingState>
        <AddressState>
          <ApparelState>
            <RecordState>
              <LiveState>
                <Router>
                  <Switch>
                    <Route exact path='/' component={Home} />
                    <Route exact path='/contactUs' component={ContactUs} />

                    <Route exact path='/login' component={LoginAccount} />
                    <Route
                      exact
                      path='/createAccount'
                      component={CreateAccount}
                    />

                    {/* APPAREL */}
                    <Route exact path='/apparel' component={Apparel} />
                    <Route exact path='/tees' component={ApparelTees} />
                    <Route
                      exact
                      path='/tees/product'
                      component={ApparelProduct}
                    />
                    <Route exact path='/hoodies' component={ApparelHoodies} />
                    <Route exact path='/masks' component={ApparelMasks} />
                    {/* /APPAREL */}

                    {/* LIVEEXPERIENCE */}
                    <Route
                      exact
                      path='/liveExperience'
                      component={LiveThrowdown}
                    />
                    <Route
                      exact
                      path='/pastEvents'
                      component={LivePastEvents}
                    />
                    <Route
                      exact
                      path='/buyTickets'
                      component={LiveBuyTickets}
                    />
                    <Route path='/delhi' component={LiveDelhi} />
                    {/* /LIVEEXPERIENCE */}

                    {/* RECORDLABEL */}
                    <Route
                      exact
                      path='/recordLabel'
                      component={RecordReleases}
                    />
                    <Route exact path='/artist' component={RecordArtists} />
                    <Route
                      exact
                      path='/submission'
                      component={RecordSubmissions}
                    />
                    {/* /RECORDLABEL */}

                    <Route exact path='/cart' component={FreeShopping} />
                    <Route
                      exact
                      path='/shipAddGuest'
                      component={ShippingAddressGuest}
                    />
                    <Route
                      exact
                      path='/addnewAddress'
                      component={AddNewAddress}
                    />
                    <Route
                      exact
                      path='/user/address'
                      component={ShippingAddressLogged}
                    />
                  </Switch>
                </Router>
              </LiveState>
            </RecordState>
          </ApparelState>
        </AddressState>
      </ShoppingState>
    </AuthState>
  );
};

export default App;
